import { copyFor } from 'config';

const getCopy = copyFor('solar.voiceSupportCard');

interface SupportCopy {
  title: string;
  paragraph: string;
}

interface Props {
  state: string;
}

export const getSupportCopy = ({ state }: Props): SupportCopy => {
  const waitlistTitle = getCopy('waitlist.title', { state });
  return {
    paragraph: getCopy('waitlist.paragraph.default', { state }),
    title: waitlistTitle,
  };
};
